import AccountService from "../../services/AccountService";

const state = {
    subscription : null,
    fetching : false
}


const mutations = {
    SET_SUBSCRIPTION(state, subscription) {
        state.subscription = subscription;

    },
    SET_FETCHING(state, value) {
        state.fetching = value;
    }
}

const actions = {
    async fetchSubscription({ commit }) {

        commit('SET_FETCHING', true);

        try {
            let {
                data
            } = await AccountService.getSubscription();
            commit('SET_FETCHING', false);

            commit('SET_SUBSCRIPTION', data.value.subscription);
        } finally {
            commit('SET_FETCHING', false);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}